<template>
  <div :disabled="button_loading" id="page-loading">
    <div>
      <vs-popup class title="Description" :active.sync="Des_popup">
        <p class="text-justify" v-if="tr">{{ tr.account_delete_reason }}</p>
      </vs-popup>
    </div>
    <div class="vx-row">
      <div class="vx-col sm:w-1/2 w-full pl-4 pb-4">
        <p class="font">{{ $t("labels.deleted_users") }}</p>
      </div>
      <div class="vx-col sm:w-1/2 w-full">
        <div class="text-right w-full">
          <vs-button
            color="success"
            type="filled"
            class="edit-user float-right"
            icon-pack="feather"
            icon="icon-search"
            :title="$t('labels.filters')"
            @click.prevent="FilterOpen()"
            >{{ $t("labels.search") }}</vs-button
          >
        </div>
      </div>
    </div>

    <vx-card class="mb-5">
      <div class="transioneffect fadeIN w-full mb-8" v-if="isOpen">
        <div class="vx-row mb-5">
          <div class="vx-col md:w-1/4 w-full mt-2">
            <vs-input
              class="w-full mt-0"
              icon-pack="feather"
              v-model="search"
              @keyup.enter="getDeleted_users()"
              icon="icon-user"
              :placeholder="$t('labels.typeby')"
              icon-no-border
              :label="$t('labels.searchby')"
            />
          </div>
          <!-- <div class="vx-col md:w-1/5 w-full mt-2">
            <label>{{$t('labels.entercity')}}</label>
            <vs-input
              class="w-full mt-0"
              icon-pack="feather"
              id="autocomplete-meeting-point"
              @keyup="googleLocation()"
              icon="icon-search"
              :placeholder="$t('labels.typecity')"
              icon-no-border
              autocomplete="on"
              v-model="city"
            />
          </div>-->

          <!-- <div class="vx-col md:w-1/5 w-full mt-2">
            <label>{{$t('labels.select_emal')}}</label>
            <v-select
              label="text"
              :clearable="false"
              :label-placeholder="$t('labels.selectEmail')"
              v-model="email_confirmed"
              :options="verifieds"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
          </div> -->

          <div class="vx-col md:w-1/4 w-full mt-2">
            <label>{{ $t("labels.type") }}</label>
            <v-select
              label="text"
              :clearable="false"
              :label-placeholder="$t('labels.type')"
              v-model="type"
              :options="AllTypes"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
          </div>
        </div>

        <div class="vx-row mb-2"></div>
        <div class="vx-row mb-2 lg:pl-2">
          <vs-button
            class="
              ml-2
              vs-component vs-button
              px-4
              w-full
              md:w-auto
              mb-1
              md:mt-0 md:mb-0
              vs-button-filled
            "
            color="success"
            type="filled"
            @click.stop="SearchFilter()"
            >{{ $t("labels.search") }}</vs-button
          >

          <vs-button
            class="
              ml-2
              vs-component vs-button
              px-4
              w-full
              md:w-auto
              mb-1
              md:mt-0 md:mb-0
              vs-button-filled
            "
            color="danger"
            type="filled"
            @click.stop="ResetFilter()"
            >{{ $t("labels.reset") }}</vs-button
          >

          <vs-button
            class="
              vs-component
              ml-2
              vs-button
              px-4
              w-full
              md:w-auto
              mb-1
              md:mt-0 md:mb-0
            "
            color="dark"
            type="filled"
            @click.stop="FilterOpen()"
            >{{ $t("labels.close") }}</vs-button
          >
        </div>
      </div>
    </vx-card>

    <vx-card>
      <div class="suser-tablel delete_users">
        <vs-table :maxItems="perPage" :data="deleted_users">
          <template slot="thead">
            <!-- <vs-th>{{$t('labels.profile_pic')}}</vs-th> -->
            <vs-th style="width: 20%">{{ $t("labels.name") }}</vs-th>
            <vs-th style="width: 20%">{{ $t("labels.email") }}</vs-th>
            <vs-th style="width: 20%">{{ $t("labels.city") }}</vs-th>
            <!-- <vs-th style="width:40%;">{{$t('labels.reason')}}</vs-th> -->
            <!-- <vs-th>{{$t('labels.action')}}</vs-th> -->
          </template>
          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <!-- <vs-td>
                <div
                  class="ttable-img cursor-pointer"
                  v-if="tr.profile_pic"
                  @click.stop="viewDetails(tr.id)"
                >
                  <vs-avatar size="90px" :src="tr.profile_pic" />
                </div>
                <div class="ttable-img" v-if="!tr.profile_pic">
                  <vs-avatar
                    size="90px"
                    
                    src="@/assets/images/kids/avatar.jpg"
                  />
                </div>
              </vs-td> -->
              <vs-td>
                <div class="flex items-center">
                  <div class="ttable-img">
                    <vs-avatar
                      size="50px"
                      v-bind:src="tr.profile_pic"
                      v-if="tr.profile_pic"
                    />
                    <vs-avatar
                      class="profile-text"
                      size="50px"
                      :text="tr.name | avtarname"
                      v-else
                    />
                  </div>
                  <span class="ml-2 text-inherit">{{ tr.name }}</span>
                </div>
              </vs-td>
              <vs-td class>
                <div class="table-btn">
                  {{ tr.email }}
                  <span v-if="tr.email_verified_at"></span>
                </div>
              </vs-td>
              <vs-td>
                <div v-if="tr.city">
                  <span v-if="tr.city">{{ tr.city }}, {{ tr.zipcode }}</span>
                  <span v-if="!tr.city">--</span>
                </div>
                <span v-if="!tr.city">--</span>
                <!-- {{tr.city ? tr.city : "-"}} -->
              </vs-td>
              <!-- <vs-td>
                {{tr.account_delete_reason ? tr.account_delete_reason : '-' }}
                <!-- <p v-if="tr.account_delete_reason">
                   {{tr.account_delete_reason.substring(0,9)}} <br>
                  <span style="font-size:11px" v-if="tr.account_delete_reason.length>9"
                    class="cursor-pointer approved"
                    @click="Open_des(tr)"
                  >{{$t('labels.read_more')}}</span>
                </p>
                <span v-if="!tr.account_delete_reason">---</span>
              </vs-td> -->

              <!-- <vs-td>
                <vs-button
                  color="success"
                  type="filled"
                  class="m-1 edit-user float-left"
                  icon-pack="feather"
                  icon="icon-eye"
                  size="small"
                  :title="$t('labels.view')"
                  @click.stop="viewDetails(tr.id)"
                ></vs-button>
              </vs-td> -->
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>

    <div style="height: 50px">
      <div class="float-left mt-5">
        <vs-pagination
          ref="paginationContact"
          :total="totalPage"
          v-model="currentPage"
        ></vs-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import axios from "axios";
export default {
  components: {
    flatPickr,
    "v-select": vSelect,
  },

  data() {
    return {
      Des_popup: false,
      backgroundLoading: "#fff",
      colorLoading: "#d84a4a",
      searchString: "",
      activeConfirm: false,
      isOpen: false,
      deleted_users: [],
      search: null,
      id: "",
      changeID: null,
      city: null,
      searchParents: "",
      value: "",
      format: "d MMM yyyy",
      fromDate: null,
      toDate: null,
      email_confirmed: {
        text: "All",
        value: null,
      },

      type: {
        text: "All",
        value: null,
      },
      AllTypes: [
        {
          text: "All",
          value: null,
        },

        {
          text: "Student",
          value: "S",
        },

        {
          text: "Teacher",
          value: "T",
        },
      ],

      verifieds: [
        {
          text: "All",
          value: null,
        },
        {
          text: "Verified",
          value: "Y",
        },
        {
          text: "Unverified",
          value: "N",
        },
      ],
      page: 1,
      perPage: 10,
      totalPage: 0,
      currentPage: 1,
    };
  },
  watch: {
    currentPage(nv) {
      if (nv) {
        // this.$route.query.page = nv;
        this.getDeleted_users();
      }
    },

    perPage(nv) {
      if (nv) {
        this.getDeleted_users();
      }
    },
    search(nv) {
      if (!nv) {
        this.perPage = 10;
        this.currentPage = 1;
        this.getDeleted_users();
      }
    },
  },

  mounted() {
    this.googleLocation();
    setTimeout(() => {
      this.getDeleted_users();
    }, 100);
  },

  methods: {
    Open_des(tr) {
      this.tr = tr;
      this.Des_popup = true;
    },
    AviewDetails(id) {
      this.$router.push("parents/views/" + id + "?page=" + this.currentPage);
    },

    loading() {
      this.loading(true, "#page-loading");
    },

    onFromChange(selectedDates, dateStr, instance) {
      this.$set(this.configTodateTimePicker, "minDate", dateStr);
    },
    onToChange(selectedDates, dateStr, instance) {
      this.$set(this.configFromdateTimePicker, "maxDate", dateStr);
    },

    getDeleted_users() {
      // this.button_loader_success(true, "#page-loading");
      let input = {
        page: this.currentPage,
        perPage: this.perPage,
        search: this.search,
        city: this.city,
        email_confirmed: this.email_confirmed
          ? this.email_confirmed.value
          : null,
        type: this.type ? this.type.value : null,

        // type: this.type ? this.type.value : null
      };

      axios
        .post("admin/deletedList", input)
        .then((response) => {
          this.button_loader_success(false, "#page-loading");
          let data = response.data.data;
          this.deleted_users = data.users;
          this.totalPage = Math.ceil(data.count / this.perPage);
          let page = this.$route.query.page;
          if (page) {
            this.currentPage = page;
          }
        })
        .catch((e) => {
          this.showError(e);
        });
    },

    googleLocation() {
      if (typeof google !== "undefined") {
        let that = this;
        let city = document.getElementById("autocomplete-meeting-point");
        var autocomplete = new google.maps.places.Autocomplete(city, {});
        google.maps.event.addListener(
          autocomplete,
          "place_changed",
          function () {
            let place = autocomplete.getPlace();
            let ac = place.address_components;
            that.getAddress(place);
          }
        );
      }
    },

    getAddress(place, reference = false) {
      let lat = place.geometry.location.lat();
      let lon = place.geometry.location.lng();
      let city = null;
      this.city = place.name;
    },

    SearchFilter() {
      this.getDeleted_users();
    },

    FilterOpen() {
      this.isOpen = !this.isOpen;
    },
    ResetFilter() {
      this.search = null;
      this.city = null;
      this.fromDate = null;
      this.toDate = null;
      (this.type = {
        text: "All",
        value: null,
      }),
        (this.email_confirmed = {
          text: "All",
          value: null,
        }),
        this.getDeleted_users();
    },
  },
};
</script>
